"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var address_row_1 = require("./address_row");
var modal_dialog_1 = require("@reverbdotcom/commons/dist/components/modal_dialog");
var bind_1 = require("../../bind");
var address_form_1 = require("./address_form");
var error_display_1 = require("../discovery/error_display");
var address_form_data_1 = require("./address_form_data");
var scroll_target_1 = require("@reverbdotcom/commons/dist/components/scroll_target");
var I18n = require("i18n-js");
var EmptyStateImage = require("../../../images/icons/empty-states/no-addresses.svg");
var with_address_book_apollo_1 = require("./with_address_book_apollo");
var PAGE_SIZE = 5;
var AddressBook = /** @class */ (function (_super) {
    tslib_1.__extends(AddressBook, _super);
    function AddressBook() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            addressFormData: address_form_data_1.buildBlankAddressFormData(),
            modalOpen: false,
            saving: false,
            shownAddressCount: PAGE_SIZE,
            addressErrors: [],
        };
        _this.addressForm = null;
        return _this;
    }
    Object.defineProperty(AddressBook.prototype, "noAddresses", {
        get: function () {
            return this.props.addresses.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddressBook.prototype, "isEditingExistingAddress", {
        get: function () {
            return this.state.modalOpen &&
                this.state.addressFormData.uuid.length > 0 &&
                !!this.addressCurrentlyEditing;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddressBook.prototype, "editedAddressIsCurrentPrimary", {
        get: function () {
            return this.noAddresses || (this.isEditingExistingAddress && this.addressCurrentlyEditing.primary);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddressBook.prototype, "addressCurrentlyEditing", {
        get: function () {
            var _this = this;
            return this.props.addresses.find(function (address) { return address.uuid === _this.state.addressFormData.uuid; });
        },
        enumerable: true,
        configurable: true
    });
    AddressBook.prototype.setAddressFormRef = function (ref) {
        this.addressForm = ref;
    };
    AddressBook.prototype.handleAddNewAddress = function () {
        this.setState({
            addressFormData: address_form_data_1.buildBlankAddressFormData(),
            modalOpen: true,
        });
    };
    AddressBook.prototype.closeModal = function () {
        this.setState({
            modalOpen: false,
            addressErrors: [],
        });
    };
    AddressBook.prototype.openModal = function () {
        this.setState({ modalOpen: true });
    };
    AddressBook.prototype.handleUpdateField = function (addressAttributes) {
        this.setState({
            addressFormData: tslib_1.__assign(tslib_1.__assign({}, this.state.addressFormData), addressAttributes),
        });
    };
    AddressBook.prototype.handleAddressEdit = function (address) {
        this.setState({
            addressFormData: address_form_data_1.buildAddressFormDataFromAddress(address),
            modalOpen: true,
        });
    };
    AddressBook.prototype.showDeleteConfirmation = function () {
        return window.confirm(I18n.t('discovery.addressBook.form.deleteConfirmation'));
    };
    AddressBook.prototype.handleDelete = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var success;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.state.saving) {
                            return [2 /*return*/];
                        }
                        if (!this.showDeleteConfirmation()) return [3 /*break*/, 2];
                        if (!this.isEditingExistingAddress) return [3 /*break*/, 2];
                        this.setState({ saving: true });
                        return [4 /*yield*/, this.props.onDelete(this.state.addressFormData.uuid)];
                    case 1:
                        success = _a.sent();
                        if (success) {
                            this.saveSuccess();
                        }
                        else {
                            this.setState({ saving: false });
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AddressBook.prototype.handleSubmit = function () {
        if (this.state.saving) {
            return;
        }
        var form = this.addressForm;
        if (form.reportValidity && !form.reportValidity()) {
            return;
        }
        this.setState({ saving: true });
        this.createOrUpdateAddress()
            .catch(this.handleErrors);
    };
    AddressBook.prototype.handleShowMore = function (e) {
        e.preventDefault();
        this.setState({ shownAddressCount: this.state.shownAddressCount + PAGE_SIZE });
    };
    AddressBook.prototype.createOrUpdateAddress = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, address, errors, _b, address, errors;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.noAddresses) {
                            this.state.addressFormData.primary = true;
                        }
                        if (!this.isEditingExistingAddress) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.onUpdate(this.state.addressFormData)];
                    case 1:
                        _a = _c.sent(), address = _a.address, errors = _a.errors;
                        this.handleResponse({ address: address, errors: errors });
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.props.onCreate(this.state.addressFormData)];
                    case 3:
                        _b = _c.sent(), address = _b.address, errors = _b.errors;
                        this.handleResponse({ address: address, errors: errors });
                        _c.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AddressBook.prototype.handleResponse = function (_a) {
        var address = _a.address, errors = _a.errors;
        if (address) {
            this.saveSuccess();
        }
        else {
            this.handleErrors(errors);
        }
    };
    AddressBook.prototype.handleErrors = function (errors) {
        this.setState({
            addressErrors: errors,
            saving: false,
        });
    };
    AddressBook.prototype.saveSuccess = function () {
        if (!this.isEditingExistingAddress) {
            this.setState({ shownAddressCount: this.state.shownAddressCount + 1 });
        }
        this.setState({
            saving: false,
            modalOpen: false,
            addressErrors: [],
        });
    };
    AddressBook.prototype.scroll = function () {
        if (this.refs.scrollTarget) {
            var typedScrollTarget = this.refs.scrollTarget;
            typedScrollTarget.scrollToTop();
        }
    };
    AddressBook.prototype.formHeaderTitle = function () {
        if (this.isEditingExistingAddress) {
            return I18n.t('discovery.addressBook.form.title.edit');
        }
        return I18n.t('discovery.addressBook.form.title.create');
    };
    AddressBook.prototype.deleteCallback = function () {
        if (this.isEditingExistingAddress && !this.editedAddressIsCurrentPrimary) {
            return this.handleDelete;
        }
        return null;
    };
    AddressBook.prototype.renderAddresses = function () {
        var _this = this;
        var addresses = this.props.addresses.slice(0, this.state.shownAddressCount);
        return addresses.map(function (address) {
            return (React.createElement(address_row_1.default, { key: address.uuid, address: address, onMakePrimary: _this.props.onMakePrimary, onEdit: _this.handleAddressEdit }));
        });
    };
    AddressBook.prototype.renderAddressList = function () {
        if (this.noAddresses) {
            return this.renderEmpty();
        }
        return (React.createElement("ul", { className: "actionable-rows" },
            this.renderAddresses(),
            this.renderPagination()));
    };
    AddressBook.prototype.renderPagination = function () {
        if (this.state.shownAddressCount >= this.props.addresses.length) {
            return null;
        }
        return (React.createElement("li", { className: "actionable-row" },
            React.createElement("div", { className: "actionable-row__content" },
                React.createElement("button", { "data-show-more-addresses": true, className: "button-as-link", onClick: this.handleShowMore }, I18n.t('discovery.addressBook.loadMore')))));
    };
    AddressBook.prototype.renderEmpty = function () {
        return (React.createElement("div", { className: "align-center", "data-no-addresses-image": true },
            React.createElement("img", { className: "d-block width-50 mlr-auto", src: EmptyStateImage, alt: "Placeholder" }),
            React.createElement("p", { className: "lh-120 mtb-2" }, I18n.t('discovery.addressBook.noAddresses'))));
    };
    AddressBook.prototype.renderPlaceholderRow = function () {
        return (React.createElement("li", { className: "actionable-row actionable-row--placeholder" },
            React.createElement("div", { className: "actionable-row__content" }),
            React.createElement("ul", { className: "actionable-row__actions" },
                React.createElement("li", { className: "actionable-row__action" }))));
    };
    AddressBook.prototype.renderPlaceholderContent = function () {
        return (React.createElement("div", { "data-placeholder-rows": true },
            React.createElement("ul", { className: "actionable-rows" },
                this.renderPlaceholderRow(),
                this.renderPlaceholderRow(),
                this.renderPlaceholderRow())));
    };
    AddressBook.prototype.render = function () {
        if (this.props.error) {
            return React.createElement(error_display_1.default, null);
        }
        if (this.props.loading) {
            return this.renderPlaceholderContent();
        }
        return (React.createElement("div", null,
            React.createElement(scroll_target_1.default, { onlyScrollUp: true, ref: "scrollTarget" }),
            this.renderAddressList(),
            React.createElement("div", { className: "mt-2 align-center" },
                React.createElement("button", { "data-add-address-button": true, onClick: this.handleAddNewAddress, className: "button button--blue" }, I18n.t('discovery.addressBook.addNewBtn'))),
            React.createElement(modal_dialog_1.default, { headerTitle: this.formHeaderTitle(), isOpen: this.state.modalOpen, onRequestClose: this.closeModal, onDelete: this.deleteCallback(), onSubmit: this.handleSubmit, isSaving: this.state.saving, backButtonText: I18n.t('discovery.checkout.addressBook.cancel'), containsFormElement: true },
                React.createElement(address_form_1.default, { addressFormData: this.state.addressFormData, countries: this.props.countries, onUpdateField: this.handleUpdateField, addressIsCurrentPrimary: this.editedAddressIsCurrentPrimary, errors: this.state.addressErrors, formRef: this.setAddressFormRef }))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], AddressBook.prototype, "setAddressFormRef", null);
    tslib_1.__decorate([
        bind_1.default
    ], AddressBook.prototype, "handleAddNewAddress", null);
    tslib_1.__decorate([
        bind_1.default
    ], AddressBook.prototype, "closeModal", null);
    tslib_1.__decorate([
        bind_1.default
    ], AddressBook.prototype, "openModal", null);
    tslib_1.__decorate([
        bind_1.default
    ], AddressBook.prototype, "handleUpdateField", null);
    tslib_1.__decorate([
        bind_1.default
    ], AddressBook.prototype, "handleAddressEdit", null);
    tslib_1.__decorate([
        bind_1.default
    ], AddressBook.prototype, "showDeleteConfirmation", null);
    tslib_1.__decorate([
        bind_1.default
    ], AddressBook.prototype, "handleDelete", null);
    tslib_1.__decorate([
        bind_1.default
    ], AddressBook.prototype, "handleSubmit", null);
    tslib_1.__decorate([
        bind_1.default
    ], AddressBook.prototype, "handleShowMore", null);
    tslib_1.__decorate([
        bind_1.default
    ], AddressBook.prototype, "handleErrors", null);
    tslib_1.__decorate([
        bind_1.default
    ], AddressBook.prototype, "saveSuccess", null);
    return AddressBook;
}(React.Component));
exports.AddressBook = AddressBook;
var AddressBookWithRQL = with_address_book_apollo_1.default(AddressBook);
exports.AddressBookWithRQL = AddressBookWithRQL;
//# sourceMappingURL=address_book.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/addresses/address_book.js
// module id = k8xt
// module chunks = 20 21